module.exports = __webpack_public_path__ + "static/media/Heros.aae12629.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Heros.png
// module id = 49
// module chunks = 0